module.exports = __webpack_public_path__ + "static/media/continue.7ecb76e7.svg";